;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"8c619fb9b2309fb3262410d731c1bfabf672ff39"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "15.1.11";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = undefined;globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/affiliates\"},{\"path\":\"/auth/callback\"},{\"path\":\"/checkout/success\"},{\"path\":\"/dashboard\"},{\"path\":\"/data-entry\"},{\"path\":\"/faq\"},{\"path\":\"/forgot-password\"},{\"path\":\"/insights\"},{\"path\":\"/inventory\"},{\"path\":\"/login\"},{\"path\":\"/mfa-verify\"},{\"path\":\"/onboarding\"},{\"path\":\"/privacy\"},{\"path\":\"/reset-password\"},{\"path\":\"/settings\"},{\"path\":\"/terms\"},{\"path\":\"/upgrade\"},{\"path\":\"/verify-email\"}],\"isrRoutes\":[]}";import * as Sentry from '@sentry/nextjs';
import { redact } from '@/lib/monitoring/scrub';

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  enabled: Boolean(process.env.NEXT_PUBLIC_SENTRY_DSN),
  environment: process.env.NODE_ENV,
  sendDefaultPii: false,

  // Lower than the server: browser traces are the noisiest and least useful
  // signal here, and the app is not a latency-sensitive product.
  tracesSampleRate: 0.05,

  // No session replay. It records the screen, and these screens show a
  // business's real takings.
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,

  beforeSend(event) {
    return redact(event) as typeof event;
  },

  ignoreErrors: [
    // Browser extensions and network blips, not application defects.
    'ResizeObserver loop',
    'Non-Error promise rejection captured',
    'Failed to fetch',
    'NetworkError',
    'AbortError',
  ],
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
